import {Button, Modal} from 'react-bootstrap'
import PropTypes from 'prop-types'
import {useUsunProfil} from "../../../../api/domain/profile/mutations/useUsunProfil.jsx";
import {Input} from "../../../common/inputs/index.js";
export const ModalUsunProfil = ({ show, handleClose, currPozycja }) => {
    const usun = useUsunProfil()

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Usuwanie profilu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz usunąć profil {currPozycja.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    disabled={usun.isPending}
                    variant='danger'
                    onClick={() => {
                        handleClose()
                        usun.mutate(currPozycja.id)
                    }}
                >
                    Usuń
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalUsunProfil.propTypes = {
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    currPozycja: PropTypes.object,
}

export const ModalOdlaczKonto = ({show, handleClose, currPozycja, isPending, onConfirm}) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Odłączanie konta od profilu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Czy na pewno chcesz odłączyć konto użytkownika o id: {currPozycja?.id}?
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    disabled={isPending}
                    variant='danger'
                    onClick={onConfirm}
                >
                    Odłącz konto
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalOdlaczKonto.propTypes = {
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    currPozycja: PropTypes.object,
    isPending: PropTypes.bool,
    onConfirm: PropTypes.func,
}

export const ModalPowiazKonto = ({
    show,
    handleClose,
    form,
    setForm,
    canSubmitPowiazanie,
    isPending,
    onSubmit,
}) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Powiąż konto z profilem</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Input
                    title={'ID użytkownika'}
                    type={'text'}
                    placeholder={'Wprowadź ID użytkownika'}
                    label={'Id użytkownika'}
                    value={form?.id}
                    onChange={(e) => setForm((prev) => ({...prev, id: e.target.value}))}
                />
                <Input
                    title={'Email użytkownika'}
                    type={'email'}
                    placeholder={'Wprowadź email użytkownika'}
                    label={'Email użytkownika'}
                    value={form?.user_email}
                    onChange={(e) => setForm((prev) => ({...prev, user_email: e.target.value}))}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                    Zamknij
                </Button>
                <Button
                    variant='success'
                    disabled={!canSubmitPowiazanie || isPending}
                    onClick={onSubmit}
                >
                    Powiąż konto
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ModalPowiazKonto.propTypes = {
    show: PropTypes.bool,
    handleClose: PropTypes.func,
    form: PropTypes.object,
    setForm: PropTypes.func,
    canSubmitPowiazanie: PropTypes.bool,
    isPending: PropTypes.bool,
    onSubmit: PropTypes.func,
}

